export default "__VITE_ASSET__Ch4x70ot__"